import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { CONTACT, BRAND } from "@/data/translations";

const FooterBrand = ({ t }) => (
    <div className="col-span-12 md:col-span-5">
        <picture>
            <source srcSet={BRAND.logoDarkWebp} type="image/webp" />
            <img
                src={BRAND.logoDark}
                alt="Fit & Wellness — Luca La Capria"
                className="h-14 w-auto mb-5"
                loading="lazy"
                decoding="async"
                width="1100"
                height="320"
            />
        </picture>
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-fw mb-4">
            {t.footer.tagline}
        </p>
        <p className="text-sm leading-relaxed max-w-sm">
            Luca La Capria — Personal Trainer, Preparatore Atletico e Consulente Alimentare. Genova, Italia.
        </p>
    </div>
);

const FooterNavColumn = ({ t }) => (
    <div className="col-span-6 md:col-span-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-fw block mb-5">
            {t.footer.method}
        </span>
        <ul className="space-y-3 text-sm">
            <li><a href="/#method" data-testid="footer-link-method" className="hover:text-fw transition-colors">{t.nav.method}</a></li>
            <li><a href="/#protocols" data-testid="footer-link-protocols" className="hover:text-fw transition-colors">{t.nav.protocols}</a></li>
            <li><a href="/#bio" data-testid="footer-link-bio" className="hover:text-fw transition-colors">{t.nav.bio}</a></li>
            <li><a href="/#testimonials" data-testid="footer-link-testimonials" className="hover:text-fw transition-colors">{t.nav.testimonials}</a></li>
            <li><a href="/#risorse" data-testid="footer-link-resources" className="hover:text-fw transition-colors">{t.nav.resources}</a></li>
            <li><a href="/#insights" data-testid="footer-link-insights" className="hover:text-fw transition-colors">{t.nav.insights}</a></li>
            <li>
                <a
                    href="https://fit-fuel-calc-1.emergent.host"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-fueling-hub"
                    className="text-fw hover:text-fw-glow transition-colors"
                >
                    {t.nav.fuelingHub}
                </a>
            </li>
        </ul>
    </div>
);

const FooterContactColumn = ({ t }) => (
    <div id="contact" className="col-span-6 md:col-span-3 scroll-mt-32">
        <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-fw block mb-5">
            {t.footer.contact}
        </span>
        <ul className="space-y-3 text-sm">
            <li>
                <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="hover:text-fw transition-colors">
                    WhatsApp · {CONTACT.phoneDisplay}
                </a>
            </li>
            <li>
                <a href={CONTACT.emailUrl} data-testid="footer-email" className="hover:text-fw transition-colors break-all">
                    {CONTACT.email}
                </a>
            </li>
        </ul>
    </div>
);

const FooterLegalColumn = ({ t }) => (
    <div className="col-span-12 md:col-span-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-fw block mb-5">
            {t.footer.legal}
        </span>
        <ul className="space-y-3 text-sm">
            <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-fw transition-colors">{t.footer.privacy}</Link></li>
            <li><Link to="/termini" data-testid="footer-link-terms" className="hover:text-fw transition-colors">{t.footer.terms}</Link></li>
        </ul>
    </div>
);

export const Footer = () => {
    const { t } = useLanguage();
    const year = new Date().getFullYear();

    return (
        <footer data-testid="site-footer" className="bg-black text-white/65 border-t border-white/10">
            <div className="mx-auto max-w-[1440px] px-5 md:px-10 lg:px-16 py-14">
                <div className="grid grid-cols-12 gap-6 lg:gap-10">
                    <FooterBrand t={t} />
                    <FooterNavColumn t={t} />
                    <FooterContactColumn t={t} />
                    <FooterLegalColumn t={t} />
                </div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.24em] text-white/50">
                    <span>© {year} Fit & Wellness · {t.footer.rights}</span>
                    <span>Made in Italia · Train. Realign. Regenerate.</span>
                </div>
            </div>
        </footer>
    );
};
